var common = require("../../utiles/common.js")
var service = require("../../utiles/service");
var layUtils = require("../../utiles/layUtils");

module.exports = {
    register: function () {
        document.createElement('user-info')
        ko.components.register('user-info', {
            viewModel: function (params) {
                var $this = this;
                $this.data = ko.observable("");
                $this.userInfo = ko.observable();
                $this.userInfo(common.fetch("/auth/personSubject/loginPerson").data);
                console.log($this.userInfo())
                $this.isenable = ko.observable("");
                $this.lastLoginDate = common.timestampToTime($this.userInfo().loginDate);

                $this.close = function(){
                    common.redirectTo("/#/appList");
                }
                $this.formData = {
                    fields: [
                        {
                            display: commonLocal.app.phone,
                            fieldName:"phone",
                            rules:["required","phone"]
                        },
                        {
                            display: commonLocal.app.mailbox,
                            fieldName:"email",
                            rules:["email"]
                        },
                    ],
                    data:$this.userInfo()?{phone:$this.userInfo().individualData.phone,email:$this.userInfo().individualData.email}:null,
                    submitText:commonLocal.app.modify,
                    callback:function(data){
                        console.log(data)
                        common.fetch("/auth/personSubject/updatePerson",{
                            type:"POST",
                            data: JSON.stringify(data),
                            success:function(result){
                                console.log(result)
                                layUtils.msg("修改成功");
                                $this.userInfo(common.fetch("/auth/personSubject/loginPerson").data);
                            }
                        });
                    }
                }
            },
            template: require("./UserInfo.html")
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/component/userInfo/UserInfo.js
// module id = 142
// module chunks = 0